import React from 'react'
import { FacebookIcon, LinkedinIcon, TwitterIcon } from '../../icons'

function Footer() {
  return (
    <div className='flex flex-col gap-[64px] px-[7.7vw] py-[64px] pb-[48px] bg-[#0C111D]'>

      <div className="flex items-center w-full justify-between max-sm:flex-col max-sm:justify-center">

        <div className="flex flex-col items-start gap-[32px] max-sm:items-center">
          <div className="flex flex-col items-start max-sm:items-center">
            <img src="/logo.png" className='w-[170px]' alt="" />
            <span className='text-[#FFFFFF] text-center'>
              Where the beats meet, memories groove.
            </span>
          </div>
          <div className="flex items-center gap-[32px] flex-wrap">
            <span className='font-[600] text-[#FFFFFF] cursor-pointer transition-all hover:text-[#1C9943]'>
              Overview
            </span>
            <span className='font-[600] text-[#FFFFFF] cursor-pointer transition-all hover:text-[#1C9943]'>
              About Us
            </span>
            <span className='font-[600] text-[#FFFFFF] cursor-pointer transition-all hover:text-[#1C9943]'>
              Treaments
            </span>
            <span className='font-[600] text-[#FFFFFF] cursor-pointer transition-all hover:text-[#1C9943]'>
              Book Consultation
            </span>
            <span className='font-[600] text-[#FFFFFF] cursor-pointer transition-all hover:text-[#1C9943]'>
              Contact Us
            </span>
            <span className='font-[600] text-[#FFFFFF] cursor-pointer transition-all hover:text-[#1C9943]'>
              Privacy
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-[16px]">

          <span className='font-[500] text-[#FFF]'>
            Get the app
          </span>

          <img src="/images/appStore.png" alt="" className='w-[135px] cursor-pointer transition-all hover:scale-95' />

          <img src="/images/googlePlay.png" alt="" className='w-[135px] cursor-pointer transition-all hover:scale-95' />

        </div>

      </div>

      <div className="flex items-center justify-center max-sm:gap-[24px] max-sm:flex-col sm:justify-between">
        <span className='text-[#667085] text-center'>
          Created with ❤️ by Team Frosty Design
        </span>

        <div className="flex items-center gap-[24px]">
          <TwitterIcon iconColor="#98A2B3" className={'cursor-pointer'} />
          <LinkedinIcon iconColor="#98A2B3" className={'cursor-pointer'} />
          <FacebookIcon iconColor="#98A2B3" className={'cursor-pointer'} />
        </div>

      </div>

    </div>
  )
}

export default Footer